export default [
  { value: 'INCREASING', label: 'Increasing' },
  { value: 'STABLE', label: 'Stable' },
  { value: 'DECREASING', label: 'Decreasing' },
];
